import { apiRequest } from "../lib/queryClient";


export function usePayments(options = {}) {
  const {
    filters = {},
    sort = { direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchPayments = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    if (sort.field) {
      queryParams.append("sortField", sort.field);
    }
    queryParams.append("sortDirection", sort.direction);
    for (const [key, value] of Object.entries(filters)) {
      queryParams.append(key, value);
    }

    const response = await apiRequest(`/admin/payment?${queryParams.toString()}`, {
      method: "GET",
    });

    return response;
  };

  return {
    fetchPayments,
  };
}
